import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { messages } from '../../../components/messages';
import { useCustomsContext } from '../../../context/context';
import style from './style.module.css';

export const CustomsWidgetFooter = () => {
  const { addDeclaration } = useCustomsContext();

  return (
    <div className={style['customs-widget-footer']}>
      <Button className={style['add-declaration-button']} onClick={addDeclaration} theme='white'>
        <FontAwesomeIcon icon={faPlus} />
        <FormattedMessage {...messages.addDeclarationLabel} />
      </Button>
    </div>
  );
};
